import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('offer-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative bg-navy text-text-light overflow-hidden pt-24 pb-20 md:pt-32 md:pb-28 px-4" data-id="element-95">
      {/* Subtle background pattern/gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--navy-light)_0%,_transparent_50%)] opacity-50" data-id="element-96" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-97">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-98">
          <div className="max-w-2xl" data-id="element-99">
            <FadeIn data-id="element-100">
              <div className="inline-block border-b border-copper pb-2 mb-6" data-id="element-101">
                <span className="text-copper font-heading tracking-widest uppercase text-sm font-semibold" data-id="element-102">
                  Official Protocol
                </span>
              </div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-shadow-sm" data-id="element-103">
                The Inherited House <br className="hidden md:block" data-id="element-104" />
                <span className="text-copper italic font-normal" data-id="element-105">
                  Survival Kit
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-106">
              <h2 className="text-xl md:text-2xl text-cream/90 font-body font-light leading-relaxed mb-10 border-l-2 border-copper/50 pl-6" data-id="element-107">
                The Anti-Foreclosure Protocol to Protect Your Sanity, Your
                Credit, and Your Inheritance.
              </h2>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-108">
              <Button onClick={scrollToOffer} className="shadow-lg" data-id="element-109">
                Get the Survival Kit — $6.39
              </Button>
              <p className="mt-4 text-sm text-cream/60 font-body tracking-wide" data-id="element-110">
                Instant PDF Download • Secure Checkout
              </p>
            </FadeIn>
          </div>

          <FadeIn delay={0.3} direction="left" className="relative mx-auto lg:ml-auto w-full max-w-md lg:max-w-lg" data-id="element-111">
            <div className="relative aspect-[3/4] md:aspect-auto" data-id="element-112">
              {/* Decorative background element for the image */}
              <div className="absolute -inset-4 bg-copper/10 blur-2xl rounded-full" data-id="element-113" />
              <img src="https://cdn.magicpatterns.com/uploads/fspLzDAjWunLPZDREyQQdf/The_Inherited_House_Survival_Kit_image.png" alt="The Inherited House Survival Kit Cover" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl transform transition-transform duration-700 hover:scale-105" data-id="element-114" />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}